import { render, staticRenderFns } from "./bSeal.vue?vue&type=template&id=244fe2bd&scoped=true&"
import script from "./bSeal.vue?vue&type=script&lang=js&"
export * from "./bSeal.vue?vue&type=script&lang=js&"
import style0 from "./bSeal.vue?vue&type=style&index=0&id=244fe2bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244fe2bd",
  null
  
)

export default component.exports